import React, { useEffect, useContext, useState, Fragment } from 'react';
import $ from 'jquery';
import DataTable from 'datatables.net';
import { LoginContext } from '../../hooks/context/LoginContext';
import useLogicForm from '../../hooks/useLogicForm';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { Spinner } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import { alertService } from '../../services/alertservice';
import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import { Alert } from '../../componentes/ui/Alert';
import LoadingPage from '../../componentes/ui/LoadingPage';
import Kpi from '../../componentes/ui/Kpi';
import MiDataTable from '../../componentes/ui/MiDataTable';
import MiDataTableDiaHorModal from './MiDataTableDiaHorModal';
import FormInput from '../../componentes/formulario/FormInput';
import FormRow from '../../componentes/formulario/FormRow';
import MiSelectLarge from '../../componentes/formulario/MiSelectLarge';
import Button from '../../componentes/ui/Button';
import MiSelect from '../../componentes/formulario/MiSelect';
import TextArea from '../../componentes/formulario/TextArea';
import MiDataTableDiaHor from './MiDataTableDiaHor';
import SpinnerFloat from '../../componentes/ui/SpinnerFloat';
import { getApiUrl, axiosPost, encryptData, getAhorayyyymmdd, getDecodedCookie, getTitle } from '../../helpers/helperApp';

$.DataTable = DataTable;

function DiaHor(props) {

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    // ***** Custom Hook - Lógica de los formularios *****
    const { loadReg } = useLogicForm()  
   
    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey, appCryptCom, centroActivo } = useContext(LoginContext);

    const [ confPantalla, saveConfPantalla ] = useState(confApp);
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ docSeleccionado, saveDocSeleccionado ] = useState(null);
    const [ backUpOptionsPlantillas, saveBackUpOptionsPlantillas ] = useState([]);
    const [ loading, saveLoading ] = useState(false);
    const [ equiposTab, saveEquiposTab ] = useState([]);
    const [ showModal, saveShowModal ] = useState(false);
    const [ loadingActionModal, saveLoadingActionModal] = useState(false);
    const [ tablaHistoria, saveTablaHistoria ] = useState([]);
    const [ tituloModal, saveTituloModal ] = useState("");
    const [ mediaActualDia, saveMediaActualDia ] = useState("");
    const [ mediaActualMes, saveMediaActualMes ] = useState("");
    const [ mediaHisDia, saveMediaHisDia ] = useState("");
    const [ mediaHisMes, saveMediaHisMes ] = useState("");
    // const [ showErrorLeidas, saveShowErrorLeidas ] = useState(false);
    

     useEffect( () => {                
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{                     
                    document.title = getTitle(confPantalla.config.trad, confPantalla.diahor.title);                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true);
                        init();
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");

                // Token cancelación axios al desmontar componentes
                source.cancel();
        } 
    },[confPantalla])

    

    const init = async () => {
        await getEquipos();
    }

    const getEquipos = async (idPlan=null) => { 
                   
        saveLoading(true);        

        const data = new FormData();      
        data.append("validacion", apiKey());
        if(idPlan != null){
            data.append("idplan", idPlan);
        }
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.diahor.controles.datatable.getdata, data, source.token);            
        if( typeof respuesta.data !== "string" ){                               
            saveEquiposTab(respuesta.data);                
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        } 

        saveLoading(false);    

    }

    const verLecturas = async (e, rowData) => {       
        saveShowModal(true);
        saveTituloModal(rowData.equipo);
        await getHistoriEquipo(rowData.idequ);
    }

    const getHistoriEquipo = async (idEquipo) => {
        saveTablaHistoria([]);
        saveMediaActualDia("");
        saveMediaActualMes("");
        saveMediaHisDia("");
        saveMediaHisMes("");
        saveLoadingActionModal(true);

        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("idequ", idEquipo);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.diahor.modal.gethistoriaequipo, data, source.token);            
        if( typeof respuesta.data !== "string" ){
            saveTablaHistoria(respuesta.data);
            if(respuesta.data[0]){                
                saveMediaActualDia(respuesta.data[0].mediaactualdia);
                saveMediaActualMes(respuesta.data[0].mediaactualmes);
                saveMediaHisDia(respuesta.data[0].mediahisdia);
                saveMediaHisMes(respuesta.data[0].mediahismes);
            }                
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }

        saveLoadingActionModal(false);
    }


    //***** HANDLES *****//
    const handleSelectPlantilla = async (selectedItem, nameOfComponent) => { 
        if( selectedItem ){            
            const docSel = backUpOptionsPlantillas.filter(option => option.value == selectedItem.value);
            saveDocSeleccionado(docSel[0]);
            await getEquipos(selectedItem.value); 
        }else{
            saveDocSeleccionado(null);
            await getEquipos(); 
        }
    }

    
    return (
        <div className="App wrapper">
            <div>
                {loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div>
                    :
                    null
                }
            </div>
            {
                confPantalla !== undefined
                    ?
                    <Fragment>
                        <Alert fondo={true} />
                        <Menusup
                            props={props}
                        />
                        <Sidebar
                            props={props}
                        />
                    </Fragment>
                    :
                    null
            }
            <div className="content-wrapper">
                <div className="content-header">
                </div>
                <section className="content">
                    {
                        !tieneNivel
                            ?
                            <PermissionRefused
                                traduction={confPantalla.config.trad.components.permissionrefused}
                            />
                            :
                            <Fragment>
                                {
                                loadedConf === true && confPantalla !== undefined
                                    ?
                                    <Section
                                        tituloenhtml={true}
                                        titulo={
                                            docSeleccionado == null
                                                ?
                                                confPantalla.diahor.section.titulo
                                                :
                                                docSeleccionado.label
                                        }
                                        icono={confPantalla.diahor.section.icono}
                                        col={confPantalla.diahor.section.col}
                                        formulario={ {id: docSeleccionado != null ? docSeleccionado.value : null} }
                                        idPrin={docSeleccionado != null ? docSeleccionado.value : null }
                                        borderHeader={docSeleccionado != null ? docSeleccionado.color : null}
                                        recurrencia={docSeleccionado != null ? docSeleccionado.recurrencia : null}                                        
                                        informes={confPantalla.diahor.controles.informes}
                                    >
                                        <FormRow>
                                            <MiSelect  
                                                estadoForm=  { "" }
                                                val=         { docSeleccionado ? docSeleccionado.value : 0  }   
                                                loading=     { loading ? true : false }
                                                id=          { confPantalla.diahor.controles.plantillas.id }    
                                                name=        { confPantalla.diahor.controles.plantillas.name }   
                                                label=       { confPantalla.diahor.controles.plantillas.label }    
                                                placeholder= { confPantalla.diahor.controles.plantillas.placeholder }
                                                col=         { confPantalla.diahor.controles.plantillas.col } 
                                                isClearable= { confPantalla.diahor.controles.plantillas.isclearable }
                                                isSearchable={ confPantalla.diahor.controles.plantillas.issearchable }
                                                dataType=    { confPantalla.diahor.controles.plantillas.datatype }
                                                data=        { confPantalla.diahor.controles.plantillas.data }
                                                required=    { confPantalla.diahor.controles.plantillas.required } 
                                                disabled=  { confPantalla.diahor.controles.plantillas.disabled }
                                                readOnly =   { confPantalla.diahor.controles.plantillas.readonly }
                                                disablethisid={confPantalla.diahor.controles.plantillas.disablethisid}
                                                disableids={confPantalla.diahor.controles.plantillas.disableids}
                                                formulario= { {id:0} }   
                                                change= { (selectedItem, nameOfComponent) => handleSelectPlantilla(selectedItem, nameOfComponent) }
                                                saveBackUpOptions={saveBackUpOptionsPlantillas}
                                            /> 
                                        </FormRow>
                                        {   loading ? 
                                                <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                                    <Spinner animation="border" />
                                                </div>                                                
                                            :
                                            null
                                        }
                                        {/* {
                                        showErrorLeidas == true
                                            ?
                                                <div className="alert alert-danger text-center" role="alert">
                                                    {confPantalla.diahor.controles.txterrorleidas.title}
                                                </div>
                                            : null
                                        }  */}
                                        <MiDataTableDiaHor 
                                                estadoForm= { "" }
                                                formulario={ {id:0} }
                                                id={"equipos"}
                                                columnas={confPantalla.diahor.controles.datatable.columns}
                                                data={equiposTab}
                                                saveData={saveEquiposTab}
                                                buttons={confPantalla.diahor.controles.datatable.buttons}
                                                ordering={confPantalla.diahor.controles.datatable.ordering}
                                                order={confPantalla.diahor.controles.datatable.order}
                                                searching={confPantalla.diahor.controles.datatable.searching}
                                                paging={confPantalla.diahor.controles.datatable.paging}
                                                select={confPantalla.diahor.controles.datatable.select}
                                                pagelength={confPantalla.diahor.controles.datatable.pagelength}                                                
                                                columnactions={confPantalla.diahor.controles.datatable.columnactions.title}
                                                linkColumns={confPantalla.diahor.controles.datatable.linkColumns}
                                                traduction={confPantalla.config.trad.components.datatable}                                                
                                                // importexcel={true}
                                                confPantalla={confPantalla}
                                                verLecturas={verLecturas}
                                                // saveShowErrorLeidas={saveShowErrorLeidas}                                            
                                            />                                        
                                    </Section>                                    
                                    :
                                    <LoadingPage />
                                }
                            </Fragment>

                    }
                    {
                    showModal == true
                    ?
                    <Modal
                        show={showModal}
                        onHide={ () => saveShowModal(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w"                                             
                    > 
                        <Modal.Header closeButton>                           
                            <h4 className='text-center'>{tituloModal}</h4>                            
                        </Modal.Header>                         
                        <Modal.Body>
                            <div className='row'>                                                              
                                    <div className="col-md-12 col-lg-6">
                                        <div className={mediaActualDia > 0 || mediaActualDia == "" ? "alert alert-success alertHelp" : "alert alert-danger alertHelp" } role="alert">
                                            {
                                                mediaActualDia != "" 
                                                ? 
                                                    <div style={{display: "flex", flexDirection: "row", alignContent: "space-between"}}>
                                                        <div className='col-6'>
                                                            {confPantalla.diahor.modal.txtmediadiaactual.title}
                                                            <span className='ml-1' style={{fontWeight: "600"}}>{mediaActualDia} </span>
                                                        </div>
                                                        <div className='col-6 text-right'>
                                                            {confPantalla.diahor.modal.txtmediamesactual.title}
                                                            <span className='ml-1' style={{fontWeight: "600"}}>{mediaActualMes} </span>
                                                        </div>
                                                    </div>
                                                : null
                                            }                                             
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-lg-6">
                                        <div className={mediaHisDia > 0  || mediaHisDia == "" ? "alert alert-success alertHelp" : "alert alert-danger alertHelp" } role="alert">
                                        {
                                                mediaHisDia != "" 
                                                ? 
                                                    <div style={{display: "flex", flexDirection: "row", alignContent: "space-between"}}>
                                                        <div className='col-6'>
                                                            {confPantalla.diahor.modal.txtmediadiahis.title}
                                                            <span className='ml-1' style={{fontWeight: "600"}}>{mediaHisDia} </span>
                                                        </div>
                                                        <div className='col-6 text-right'>
                                                            {confPantalla.diahor.modal.txtmediameshis.title}
                                                            <span className='ml-1' style={{fontWeight: "600"}}>{mediaHisMes} </span>
                                                        </div>
                                                    </div>
                                                : null
                                            }                                            
                                        </div>
                                    </div>                                                                                          
                            </div>
                            <MiDataTableDiaHorModal 
                                estadoForm= { "" }
                                formulario={ {id:0} }
                                id={"historia"}
                                columnas={confPantalla.diahor.modal.datatable.columns}
                                data={tablaHistoria}
                                buttons={confPantalla.diahor.modal.datatable.buttons}
                                ordering={confPantalla.diahor.modal.datatable.ordering}
                                order={confPantalla.diahor.modal.datatable.order}
                                searching={confPantalla.diahor.modal.datatable.searching}
                                paging={confPantalla.diahor.modal.datatable.paging}
                                select={confPantalla.diahor.modal.datatable.select}
                                pagelength={confPantalla.diahor.modal.datatable.pagelength}                                            
                                // loadingTable={loading}
                                columnactions={confPantalla.diahor.modal.datatable.columnactions.title}
                                linkColumns={confPantalla.diahor.modal.datatable.linkColumns}
                                traduction={confPantalla.config.trad.components.datatable}
                            />                                                                                
                            {   loadingActionModal ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }                            
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>                                
                                <button 
                                        className="btn btn-danger mt-1"
                                        onClick={ () => saveShowModal(false) }                                        
                                >
                                    {confPantalla.config.trad.components.modal.btncerrar.title}
                                </button>                                            
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                    :
                        null
                    }
                </section>
            </div>
            <Footer />
        </div>
    );

}
export default DiaHor